import { createFileRoute, Outlet } from '@tanstack/react-router'
import { RouteLayout } from '@web/app/components'
import { FileText } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/documents')({
  component: RouteComponent,
  staticData: {
    metaRoute: {
      title: 'Documentos',
      icon: FileText
    },
  },
})

function RouteComponent() {
  return (
    <RouteLayout>
<Outlet />
    </RouteLayout>
  )
}
